import {isNil} from 'ramda';
import {isString} from './Common';

export type RescuableError = Error & {
  rescuable: boolean;
  extra: unknown;
};
export function rescuableReject(message: string, extra?: unknown): Promise<unknown> {
  return Promise.reject(rescuableError(message, extra));
}
export function isError(error: unknown): error is Error {
  return !isNil(error) && typeof error === 'object' && 'message' in error;
}
export function isRescuableError(error: unknown): error is RescuableError {
  return isError(error) && 'rescuable' in error && 'extra' in error;
}
export function coerceToError(something: unknown): RescuableError {
  if (isRescuableError(something)) return something;
  const error = isError(something) ? something : new Error(String(something));
  return Object.assign(error, {rescuable: false, extra: {}});
}
export function rescuableError(something: unknown, extra?: unknown): RescuableError {
  const error = coerceToError(something);
  error.rescuable = true;
  error.extra = extra || {};
  return error;
}
export function mergeErrors(errors: Error[]): Maybe<Error> {
  if (errors.length === 0) return null;
  // @ts-ignore RescuableError coercion
  const rescuableErrors: RescuableError[] = errors;
  // @ts-ignore RescuableError coercion
  const error: RescuableError = new Error('Multiple Errors');
  error.rescuable = rescuableErrors.every(e => e.rescuable);
  error.extra = rescuableErrors.map(errorToJson);
  return error;
}
export type JsonError = {
  name: string;
  message: string;
  stack: string;
  rescuable: boolean;
  extra: unknown;
};
export function errorToJson(maybeError: Error | string): JsonError {
  //@ts-ignore
  if (maybeError?.message) {
    // @ts-ignore RescuableError coercion
    const error: RescuableError = maybeError;
    return {
      name: error.name,
      message: error.message,
      stack: error.stack || '',
      rescuable: error.rescuable || false,
      extra: error.extra,
    };
  }
  if (isString(maybeError)) {
    return {
      name: 'No name',
      message: maybeError,
      stack: '',
      rescuable: false,
      extra: null,
    };
  }
  return {
    name: 'No name',
    message: 'No message',
    stack: '',
    rescuable: false,
    extra: maybeError || null,
  };
}
